import { createAdminMessage, createMessages, SB } from '@play-co/replicant';
import { Admin } from './';
import { Pet } from '../buruburu/pet';

export default (
  Admin: Pick<Admin, 'schema'>,
  { Inventory }: Admin['$DEPENDENCIES'],
) =>
  createMessages(
    SB.object({ ...Admin.schema, ...Inventory.schema, ...Pet.schema }),
  )({
    /**
     * Add coins over admin  message
     */
    admin_addCoins: createAdminMessage(
      SB.object({ amount: SB.int().min(0), reason: SB.string() }),
      (state, args, info) => {
        // Log reimbursement so the user can claim it manually.
        state.admin.push({
          coins: args.amount,
          freeGems: 0,

          reason: args.reason,
          claimed: false,

          timestamp: info.timestamp,
        });
      },
      'Add Coins',
    ),

    /**
     * Remove coins over admin message
     */
    admin_removeCoins: createAdminMessage(
      SB.object({ amount: SB.int().min(0), reason: SB.string() }),
      (state, args, info) => {
        // Claim penalty immediately so the user cannot avoid it.
        const points = Inventory.getters(state).getPoints();
        const remove = Math.max(0, points - args.amount);

        if (remove > 0) {
          Inventory.modifiers(state).consumePoints(remove);
        } else {
          Inventory.modifiers(state).setPoints(0);
        }

        // Log penalty as claimed.
        state.admin.push({
          coins: -args.amount,
          freeGems: 0,

          reason: args.reason,
          claimed: true,

          timestamp: info.timestamp,
        });
      },
      'Remove Coins',
    ),

    /**
     * Set coins over admin message
     */
    admin_setCoins: createAdminMessage(
      SB.object({ amount: SB.int().min(0), reason: SB.string() }),
      (state, args, info) => {
        // Claim penalty immediately so the user cannot avoid it.
        Inventory.modifiers(state).setPoints(Math.max(0, args.amount));

        // Log penalty as claimed.
        state.admin.push({
          coins: args.amount,
          freeGems: 0,

          reason: args.reason,
          claimed: true,

          timestamp: info.timestamp,
        });
      },
      'Set Coins',
    ),

    /**
     * Add free gems over admin message
     */
    admin_addFreeGems: createAdminMessage(
      SB.object({ amount: SB.int().min(0), reason: SB.string() }),
      (state, args, info) => {
        // Log reimbursement so the user can claim it manually.
        state.admin.push({
          coins: 0,
          freeGems: args.amount,

          reason: args.reason,
          claimed: false,

          timestamp: info.timestamp,
        });
      },
      'Add Free Gems',
    ),

    /**
     * Remove gems over admin message
     */
    admin_removeGems: createAdminMessage(
      SB.object({ amount: SB.int().min(0), reason: SB.string() }),
      (state, args, info) => {
        // Claim penalty immediately so the user cannot avoid it.
        const gems = Inventory.getters(state).getGems();
        const remove = Math.max(0, gems - args.amount);

        if (remove > 0) {
          Inventory.modifiers(state).consumeGems(remove);
        } else {
          Inventory.modifiers(state).setFreeGems(0);
        }

        // Log penalty as claimed.
        state.admin.push({
          coins: 0,
          freeGems: -args.amount,

          reason: args.reason,
          claimed: true,

          timestamp: info.timestamp,
        });
      },
      'Remove Gems',
    ),

    /**
     * Set free gems over admin message
     */
    admin_setFreeGems: createAdminMessage(
      SB.object({ amount: SB.int().min(0), reason: SB.string() }),
      (state, args, info) => {
        // Claim penalty immediately so the user cannot avoid it.
        Inventory.modifiers(state).setFreeGems(Math.max(0, args.amount));

        // Log penalty as claimed.
        state.admin.push({
          coins: 0,
          freeGems: args.amount,

          reason: args.reason,
          claimed: true,

          timestamp: info.timestamp,
        });
      },
      'Set Free gems',
    ),
  });
